export const getSlotServicibility = (details = {}) => {
    if (details.zone) return "Hi_Slot";
    if (details.locations && details.locations.length > 0) return "Only_branch";
    return "Non_servicable";
};
